import {Component, EventEmitter, OnInit} from '@angular/core';
import {ITooltipComponent} from '@shared/models/common.models';

@Component({
    standalone: false,
    selector: 'particle-data-survey-topic-tooltip',
  templateUrl: './data-survey-topic-tooltip.component.html',
  styleUrls: ['./data-survey-topic-tooltip.component.scss']
})
export class DataSurveyTopicTooltipComponent implements OnInit, ITooltipComponent {
  inputMetadata: any;
  action: EventEmitter<any> = new EventEmitter<any>();

  constructor() {
  }

  ngOnInit() {
  }
}
